import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FooterContext } from "@insite/content-library/Pages/Footer";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    contactWrap?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    linkList1GridItem: {
        width: [12, 12, 12, 3, 3],
        css: css`
            img {
                width: auto;
                max-width: 190px;
            }
        `,
    },
    linkList2GridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            color: #000;
        `,
    },
    linkList3GridItem: {
        width: [12, 12, 12, 3, 3],
    },
    contactWrap: {
        css: css`
            margin-top: -25px;
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <>
            <GridContainer {...styles.widgetGridContainer}>
                <GridItem {...styles.linkList1GridItem}>
                    <Zone zoneName="LinkList1" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkList2GridItem}>
                    <Zone zoneName="LinkList2" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkList3GridItem}>
                    <StyledWrapper {...styles.contactWrap}>
                        <Zone zoneName="LinkList3" contentId={id} />
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
